export enum FeedTypes {
  FAP = 'fap',
  PORN = 'porn',
  FAPS = 'faps',
  FAPS_PREVIEW = 'faps_preview',
  VIDEO = 'video',
  VIDEO_PREVIEW = 'preview',
  MEDIA = 'media',
  ADS = 'ads',
  ACTRESSES = 'actresses',
  ACTRESS = 'actress',
  CATEGORY = 'category',
  USER = 'user',
}